<template></template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { Carousel, Slide } from 'vue-carousel'
import Modal from 'vue-lightweight-modal'
import ReservationForm from './ReservationForm.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import api from '../services/api'

@Component({
  components: {
    Modal,
    ReservationForm,
    Carousel,
    Slide,
    VueEasyLightbox,
  }
})
export default class Reservation extends Vue {

  socialAreas = [];
  areaTabSelected = 0
  isOpenBooking = false
  socialSelected = null
  isopenSlide = false
  slide = []
  slideIndex = 0

  mounted() {
    this.getData();
  }

  async getData() {
    try {
      const response = await api.post('/social-areas/filters', {status: 'active', condominium_id: 1})
      this.socialAreas = response.data.records
      if (this.socialAreas.length>0) {
        this.areaTabSelected = this.socialAreas[0].id
      }
    } catch (error) {
      //const toast = await showErrorToast(error.status, 'El acceso a expirado, inicie sesión nuevamente.', 'Error al guardar listar las Áreas sociales.')
      //toast.present()
    }
  }

  openBooking(data) {
    this.socialSelected = data
    this.isOpenBooking = true
  }

  closeBooking() {
    this.socialSelected = null
    this.isOpenBooking = false
  }

  openSlide(index, item) {
    this.slide = []
    item.gallery.forEach((p) => {
      this.slide.push(p.url)
    })
    this.slideIndex = index
    this.isopenSlide = true
  }

  handleSlide() {
    this.isopenSlide = false
  }

  bindReservations(data) {
    console.log('Reservas públicas actualizadas:', data);
  }
}
</script>